import { isThirdPartyMapsConsentGranted } from 'src/cookieConsent/cookieConsentApi';
import { useCookieConsentRevision } from 'src/cookieConsent/CookieConsentProvider';

export default function useThirdPartyMapsConsent(): boolean {
  const revision = useCookieConsentRevision();
  void revision;
  return isThirdPartyMapsConsentGranted();
}
